import { Plugin } from './Plugin';
import { GlobalsPlugin } from './GlobalsPlugin';
import { RotatePlugin } from './RotatePlugin';
import { MovePlugin } from './MovePlugin';
import { TAARenderPass } from 'three/examples/jsm/postprocessing/TAARenderPass.js';
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

export class TAAPlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.dependencies.add(GlobalsPlugin);
		this.dependencies.add(RotatePlugin);
		this.dependencies.add(MovePlugin);


		this.viewer.rendering.disableRenderPass = true;
		this.taa = new TAARenderPass(this.viewer.rendering.scene, this.viewer.rendering.camera);
		this.taa.unbiased = false;
		this.viewer.rendering.customPasses.add(this.taa);

		this.gammaPass = new ShaderPass( GammaCorrectionShader );
		this.viewer.rendering.customPasses.add(this.gammaPass);
	}

	attach(){
		this.viewer.rendering.ticker.on('tick', this.render);
	}

	detach(){
		this.viewer.rendering.ticker.off('tick', this.render);
	}

	update(){
		this.manager.get(GlobalsPlugin).antialias = false;
	}

	render = () => {
		// this.taa.accumulate = !this.manager.get(RotatePlugin).rotating && !this.manager.get(MovePlugin).moving
	}
}